import { render, staticRenderFns } from "./DashboardImageThreshold.vue?vue&type=template&id=2a27b268&"
import script from "./DashboardImageThreshold.vue?vue&type=script&lang=js&"
export * from "./DashboardImageThreshold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports